import { colors } from '@lib/colors/colors'
import parseTreatments from '@modules/interventions/helpers/parseTreatmentsFromTrial'
import { MINDMED_GAD_PHASE_3_SISTER_TRIAL } from '@modules/trials/constants/trials'
import { type ClinicalTrialForListingPage } from '@modules/trials/helpers/fragments/clinicalTrialListingFragment'
import { isMindMedGad3 } from '@modules/trials/helpers/isHardcodedTrial'
import sortBy from 'lodash/sortBy'

export default function getArmGroupsForTrialDesign(
  trial: Pick<
    ClinicalTrialForListingPage,
    'armGroups' | 'interventions' | 'nctId'
  >,
) {
  const { controlTreatments, experimentalTreatments } = parseTreatments(trial)

  const activeComparators = controlTreatments.filter(
    (armGroup) =>
      !['PlaceboComparator', 'ShamComparator'].includes(armGroup.type),
  )
  const placeboComparators = controlTreatments.filter((armGroup) =>
    ['PlaceboComparator', 'ShamComparator'].includes(armGroup.type),
  )

  const experimentalTreatmentGroups = sortBy(
    experimentalTreatments.map((group) => ({
      color: colors.blue500,
      description: group.description,
      name: group.name,
      treatments:
        // Sponsor request
        trial.nctId === MINDMED_GAD_PHASE_3_SISTER_TRIAL.nctId
          ? []
          : group.treatments,
      type: 'Experimental Treatment' as const,
    })),
    'name',
  )

  const armGroups = [
    ...(isMindMedGad3(trial.nctId)
      ? experimentalTreatmentGroups
      : experimentalTreatmentGroups.reverse()),
    ...activeComparators.map((group) => ({
      color: colors.success500,
      description: group.description,
      name: group.name,
      treatments: group.treatments,
      type: 'Active Control' as const,
    })),
    ...placeboComparators.map((group) => ({
      color: colors.neutral300,
      description: group.description,
      name: group.name,
      treatments: group.treatments,
      type: 'Placebo Group' as const,
    })),
  ]

  return armGroups
}
